import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
} from '@mui/material'
import { Button, Box } from '@material-ui/core'

import { LinkedZendeskTicketsTable } from './components/LinkedZendeskTicketsTable'
import { useEffect, useState } from 'react'
import { ZendeskTicketSearchTable } from './components/ZendeskTicketSearchTable'
import { getZendeskTickets } from '../Apis/routes/zendesk'
import CloseIcon from '@mui/icons-material/Close'
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'

const VIEW_LINKED = 'linked'
const VIEW_SEARCH = 'search'
export const DRAFT_TICKET_TYPE = 'draft-ticket'

export const ZendeskModal = ({ open, handleClose, ticket, type }) => {
  const [activeView, setActiveView] = useState(VIEW_LINKED)
  const [zendeskTickets, setZendeskTickets] = useState([])
  useEffect(() => {
    getZendeskTickets(ticket.id, type).then((res) => {
      setZendeskTickets(res)
    })
  }, [activeView])

  const displayTitle = () => {
    if (activeView === VIEW_LINKED) {
      return 'TICKETS ZENDESK LIÉS'
    } else {
      return 'LIER UN NOUVEAU TICKET ZENDESK'
    }
  }

  return (
    <Dialog fullWidth maxWidth="lg" open={open} onClose={handleClose}>
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        {activeView === VIEW_SEARCH && (
          <Button
            startIcon={<KeyboardArrowLeftIcon fontSize="large" />}
            onClick={() => {
              setActiveView(VIEW_LINKED)
            }}
            color="primary"
            size="large"
          >
            Retour
          </Button>
        )}
        <Box sx={{ textAlign: 'center', flex: 1 }}>
          <Typography variant="h5">{displayTitle()}</Typography>
          <Typography variant="subtitle1">{`${
            ticket.reference || ticket.id
          } - ${ticket.code}`}</Typography>
        </Box>
        <IconButton
          size="large"
          sx={{ position: 'absolute', right: 15, top: 15 }}
          onClick={handleClose}
        >
          <CloseIcon fontSize="large" />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ paddingBottom: 0 }}>
        {activeView === VIEW_LINKED ? (
          <LinkedZendeskTicketsTable
            ticketId={ticket.id}
            zendeskTickets={zendeskTickets}
            setZendeskTickets={setZendeskTickets}
            navigateToSearchView={() => setActiveView(VIEW_SEARCH)}
            type={type}
          />
        ) : (
          <ZendeskTicketSearchTable
            ticketId={ticket.id}
            zendeskTicketsAlreadyLinked={zendeskTickets}
            navigateToLinkedView={() => {
              setActiveView(VIEW_LINKED)
            }}
            type={type}
          />
        )}
      </DialogContent>
    </Dialog>
  )
}
